import React from 'react';
import { useIsEligibleForProMigration } from './useIsEligibleForProMigration';
import { MigrationStepContent } from './MigrationStepContent';

export const ProMigrationStep = () => {
  const { isVeryHighBudget, isHourly, isHighBudget } = useIsEligibleForProMigration();

  if (isVeryHighBudget) {
    return <MigrationStepContent migrationType="high_budget" />;
  }

  if (isHourly) {
    return <MigrationStepContent migrationType="hourly" />;
  }

  if (isHighBudget) {
    return <MigrationStepContent migrationType="rewards_program" />;
  }

  return null;
};
